module.exports = __webpack_public_path__ + "static/media/hocsere_3.5d08c5f0.gif";